import type { FileRouteTypes } from '@client/routeTree.gen';
import type { Tree } from '@client/utils';

export type NavigationItem = {
    title: string;
    tag?: {
        label?: string;
        color?: string;
        /** Feature flag key that controls visibility of this navigation item */
        featureFlag?: string;
    };
    to: FileRouteTypes['to'];
    preloadFn?: () => Promise<void>;
};

export type NavigationTree = Tree<NavigationItem>;

export type CommonBreadCrumbItem = {
    inactive?: true;
};

/**
 * Removes the trailing slash TanStack Router adds to layout-route `fullPath`s (except for the
 * root `/`), so match paths compare against navigation paths and route-access checks.
 */
export function normalizeRoutePath<T extends string>(path: T): T {
    if (path === '/') return path;
    return path.replace(/\/$/, '') as T;
}
